/**
 * links.js — where each kind of thing is read
 * ===========================================
 * Usability review of 23 October 2026, item 3: *"Clicking a ticker on the
 * Dashboard should open its deal report, and a deal should link back to its
 * position, its notices and its documents. Today each page is a dead end."*
 *
 * One function per destination, so a page that links somewhere and the page
 * that answers the link agree on the address.
 */

/** A deal's report: its own page, by the deal's id. */
export const dealReportPath = (dealId) =>
  dealId === null || dealId === undefined || dealId === "" ? "/deal-reports" : `/deal-reports/${dealId}`;

/** The Positions page, filtered to a search (a ticker, a deal, an issuer). */
export const positionsPath = (query) =>
  query ? `/positions?q=${encodeURIComponent(query)}` : "/positions";

/** The Ledger, filtered to a search. */
export const ledgerPath = (query) =>
  query ? `/ledger?q=${encodeURIComponent(query)}` : "/ledger";

/** The Securities page, filtered to a search. */
export const securitiesPath = (query) =>
  query ? `/securities?q=${encodeURIComponent(query)}` : "/securities";

/** The Dashboard's positions table, filtered to a search. */
export const dashboardPath = (query) =>
  query ? `/dashboard?q=${encodeURIComponent(query)}` : "/dashboard";

/** Notice Review, the morning queue. */
export const noticeReviewPath = () => "/notice-review";

/** Bank Feed, optionally opened on the unposted queue. */
export const bankFeedPath = () => "/bank-feed";

/** Reads `?q=` off the current address, for a page that takes a search link. */
export const queryParam = (search, name = "q") => {
  try {
    return new URLSearchParams(search || "").get(name) || "";
  } catch {
    return "";
  }
};
